import { render, staticRenderFns } from "./PDFDialog.vue?vue&type=template&id=ba5ed59c"
import script from "./PDFDialog.vue?vue&type=script&lang=ts"
export * from "./PDFDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports